"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";

interface ContactUsActionProps {
  href?: string;
  label?: string;
  className?: string;
  testId?: string;
}

export default function ContactUsAction({
  href = "/contact",
  label = "Contact Us",
  className = "",
  testId = "contact-us-action",
}: ContactUsActionProps) {
  return (
    <Link
      href={href}
      data-testid={testId}
      aria-label="Open Contact Us form"
      className={[
        "inline-flex min-h-10 items-center justify-center gap-2 rounded-full border border-blue-200 bg-white px-4 py-2 text-sm font-semibold text-blue-700 shadow-sm transition-colors",
        "hover:bg-blue-50 hover:text-blue-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
        className,
      ].join(" ")}
    >
      <span>{label}</span>
      <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" />
    </Link>
  );
}
